import { User } from './user'
import { Tenant, TenantScope } from './tenant'
import { Audited } from './audited'
import { LocCharge } from './location'
import { Availability } from './availability'

export const TypeVehicule = {
  MOTO: 'MOTO',
  QUAD: 'QUAD',
  VOITURE_MANUELLE: 'VOITURE_MANUELLE',
  VOITURE_AUTO: 'VOITURE_AUTO',
  VALUES: ['MOTO', 'QUAD', 'VOITURE_MANUELLE', 'VOITURE_AUTO']
}

export class Car extends TenantScope {
  constructor (obj) {
    super(obj)

    if (!obj) {
      return
    }

    this.id = obj.id
    this.immat = obj.immat
    this.model = obj.model
    this.registrationDate = new Date(obj.registrationDate)

    this.km = obj.km
    this.nbrPlace = obj.nbrPlace
    this.niveauCarburant = obj.niveauCarburant
    this.actif = !!obj.actif
    this.deleted = !!obj.deleted
    this.location = !!obj.location
    if (obj.loueur) {
      this.loueur = new Loueur(obj.loueur)
    }
    this.locationStart = new Date(obj.locationStart)
    this.locationEnd = new Date(obj.locationEnd)
    this.note = obj.note
    if (obj.charge) {
      this.charge = obj.charge
    }
    if (obj.carCategorie) {
      this.carCategorie = new CarCategorie(obj.carCategorie)
    }
    this.type = obj.type
    if (obj.driver) {
      this.driver = new User(obj.driver)
    }
    this.files = []
    if (obj.files && obj.files.length) {
      this.files = obj.files
    }
    this.observations = []
    if (obj.observations && obj.observations.length) {
      this.observations = obj.observations
    }
    this.agency = obj.agency
    this.tenantName = obj.tenantName
  }
}

export class CarCategorie {
  constructor (obj) {
    if (!obj) {
      return
    }

    this.id = obj.id
    if (obj.tenant) {
      this.tenant = new Tenant(obj.tenant)
    }
    this.designation = obj.designation
    this.description = obj.description
    this.caution = obj.caution
    this.prixKMAdditionel = obj.prixKMAdditionel
  }
}

export class CarCheck extends Audited {
  constructor (obj) {
    super(obj)

    if (!obj) {
      return
    }

    this.id = obj.id
    this.km = obj.km
    this.niveauCarburant = obj.niveauCarburant
    this.observation = obj.observation
    this.validated = !!obj.validated
  }
}

export class AvailabilityCar {
  constructor (obj) {
    if (!obj) {
      return
    }

    this.id = obj.id
    this.model = obj.model
    this.category = obj.category
    this.nbrPlace = obj.nbrPlace
    this.registrationDate = new Date(obj.registrationDate)
    this.note = obj.note
    this.type = obj.type
    this.duration = obj.duration
    this.prix = []
    if (obj.prix && obj.prix.length) {
      this.prix = obj.prix.map(p => new LocCharge(p))
    }
    this.supplementsPrix = []
    if (obj.supplementsPrix && obj.supplementsPrix.length) {
      this.supplementsPrix = obj.supplementsPrix.map(sp => new LocCharge(sp))
    }
    this.cautions = []
    if (obj.cautions && obj.cautions.length) {
      this.cautions = obj.cautions.map(sp => new LocCharge(sp))
    }
    if (obj.availability) {
      this.availability = new Availability(obj)
    }
    this.key = obj.key
    this.agency = obj.agency
    this.tenantName = obj.tenantName
  }

  get prixTTC () {
    return this.prix && this.prix.length ? this.prix[0].ttc : 0
  }

  get supplementsPrixTTC () {
    var totalSup = 0
    for (var i = 0; this.supplementsPrix && i < this.supplementsPrix.length; i++) {
      totalSup = totalSup + this.supplementsPrix[i].ttc
    }
    return totalSup
  }

  get getCaution () {
    return this.cautions && this.cautions.length ? this.cautions[0].ttc : 0
  }

  get totalTTC () {
    return this.prixTTC + this.supplementsPrixTTC
  }

  static addOptions (availabilityCar, options) {
    availabilityCar.supplementsPrix.push(new LocCharge({
      ttc: options.totalAdditionnel
    }))
  }

  static setOptions (availabilityCar, products) {
    console.log('SetOption', products)
    availabilityCar.supplementsPrix = []
    products.forEach(product => {
      if (product.number > 0) {
        availabilityCar.supplementsPrix.push(new LocCharge({
          chargeType: 'OPTION',
          libele: product.name,
          description: product.type + ' ' + product.number + ' * ' + product.prix,
          ttc: product.total
        }))
      }
    })

  }
}
